module.exports = __webpack_public_path__ + "static/media/payment2.cd0230a1.png";